export const CountryList = [
  { name: "KSA", image: "sa.svg", years: ["2025", "2026"] },
  { name: "India", image: "in.svg", years: ["2025", "2026"] },
  { name: "United Kingdom", image: "gb.svg", years: ["2025", "2026"] },
  { name: "Qatar", image: "qa.svg", years: ["2025", "2026"] },
  { name: "UAE", image: "ae.svg", years: ["2025", "2026"] },
  { name: "United States", image: "us.svg", years: ["2025", "2026"] },
  { name: "France", image: "fr.svg", years: ["2025", "2026"] },
  { name: "Germany", image: "de.svg", years: ["2025", "2026"] },
  { name: "Canada", image: "ca.svg", years: ["2025", "2026"] },
  { name: "Australia", image: "au.svg", years: ["2025"] },
  { name: "Mexico", image: "mx.svg", years: ["2025", "2026"] },
  { name: "China", image: "cn.svg", years: ["2025", "2026"] },
  { name: "Japan", image: "jp.svg", years: ["2025"] },
  { name: "Brazil", image: "br.svg", years: ["2025"] },
  { name: "South Africa", image: "za.svg", years: ["2025"] },
  { name: "Italy", image: "it.svg", years: ["2025"] },
  { name: "Spain", image: "es.svg", years: ["2025"] },
  { name: "Russia", image: "ru.svg", years: ["2025"] },
  { name: "Indonesia", image: "id.svg", years: ["2025"] },
  { name: "Egypt", image: "eg.svg", years: ["2025"] },
  { name: "Turkey", image: "tr.svg", years: ["2025"] },
  { name: "South Korea", image: "kr.svg", years: ["2025"] },
  { name: "Nigeria", image: "ng.svg", years: ["2025"] },
  { name: "Argentina", image: "ar.svg", years: ["2025"] },
  { name: "Netherlands", image: "nl.svg", years: ["2025"] },
  { name: "Sweden", image: "se.svg", years: ["2025"] },
  { name: "Switzerland", image: "ch.svg", years: ["2025"] },
  { name: "Thailand", image: "th.svg", years: ["2025"] },
  { name: "Singapore", image: "sg.svg", years: ["2025"] },
  { name: "Malaysia", image: "my.svg", years: ["2025"] },
  { name: "New Zealand", image: "nz.svg", years: ["2025"] },
  { name: "Poland", image: "pl.svg", years: ["2025"] },
  { name: "Belgium", image: "be.svg", years: ["2025"] },
  { name: "Norway", image: "no.svg", years: ["2025"] },
  { name: "Denmark", image: "dk.svg", years: ["2025"] },
  { name: "Finland", image: "fi.svg", years: ["2025"] },
  { name: "Ireland", image: "ie.svg", years: ["2025"] },
  { name: "Austria", image: "at.svg", years: ["2025"] },
  { name: "Portugal", image: "pt.svg", years: ["2025"] },
  { name: "Greece", image: "gr.svg", years: ["2025"] },
  { name: "Israel", image: "il.svg", years: ["2025"] },
  { name: "Chile", image: "cl.svg", years: ["2025"] },
  { name: "Colombia", image: "co.svg", years: ["2025"] },
  { name: "Peru", image: "pe.svg", years: ["2025"] },
  { name: "Vietnam", image: "vn.svg", years: ["2025", "2026"] },
  { name: "Philippines", image: "ph.svg", years: ["2025"] },
  { name: "Pakistan", image: "pk.svg", years: ["2025"] },
  { name: "Bangladesh", image: "bd.svg", years: ["2025"] },
  { name: "Kenya", image: "ke.svg", years: ["2025"] },
  { name: "Morocco", image: "ma.svg", years: ["2025"] },
  { name: "Algeria", image: "dz.svg", years: ["2025"] },
  { name: "Ukraine", image: "ua.svg", years: ["2025"] },
  { name: "Romania", image: "ro.svg", years: ["2025"] },
  { name: "Czech Republic", image: "cz.svg", years: ["2025"] },
  { name: "Hungary", image: "hu.svg", years: ["2025"] },
  { name: "Slovakia", image: "sk.svg", years: ["2025"] },
  { name: "Bulgaria", image: "bg.svg", years: ["2025"] },
]; 


 export const holidayData = [
  {
    id: 1,
    name: "Independence Day",
    date: "04/07/2025",
    type: "National",
    status: "Active",
    country: "USA",
  },
  {
    id: 2,
    name: "Diwali",
    date: "20/10/2025",
    type: "Religious",
    status: "Active",
    country: "India",
  },
  {
    id: 3,
    name: "Christmas",
    date: "25/12/2025",
    type: "Religious",
    status: "Inactive",
    country: "Global",
  },
  {
    id: 4,
    name: "Eid al-Fitr",
    date: "30/03/2025",
    type: "Religious",
    status: "Active",
    country: "KSA",
  },
  {
    id: 5,
    name: "Thanksgiving",
    date: "27/11/2025",
    type: "National",
    status: "Active",
    country: "USA",
  },
  {
    id: 6,
    name: "Chinese New Year",
    date: "29/01/2025",
    type: "Cultural",
    status: "Active",
    country: "China",
  },
  {
    id: 7,
    name: "Bastille Day",
    date: "14/07/2025",
    type: "National",
    status: "Active",
    country: "France",
  },
  {
    id: 8,
    name: "Holi",
    date: "09/03/2025",
    type: "Religious",
    status: "Active",
    country: "India",
  },
  {
    id: 9,
    name: "Canada Day",
    date: "01/07/2025",
    type: "National",
    status: "Active",
    country: "Canada",
  },
  {
    id: 10,
    name: "Rosh Hashanah",
    date: "22/09/2025",
    type: "Religious",
    status: "Active",
    country: "Israel",
  },
  {
    id: 11,
    name: "Day of the Dead",
    date: "01/11/2025",
    type: "Cultural",
    status: "Active",
    country: "Mexico",
  },
  {
    id: 12,
    name: "Australia Day",
    date: "26/01/2025",
    type: "National",
    status: "Active",
    country: "Australia",
  },
  {
    id: 13,
    name: "Vesak",
    date: "12/05/2025",
    type: "Religious",
    status: "Inactive",
    country: "Sri Lanka",
  },
  {
    id: 14,
    name: "Oktoberfest",
    date: "20/09/2025",
    type: "Cultural",
    status: "Active",
    country: "Germany",
  },
  {
    id: 15,
    name: "Labor Day",
    date: "01/09/2025",
    type: "Public",
    status: "Active",
    country: "USA",
  },
  {
    id: 16,
    name: "Eid al-Adha",
    date: "06/06/2025",
    type: "Religious",
    status: "Active",
    country: "KSA",
  },
  {
    id: 17,
    name: "Lunar New Year",
    date: "29/01/2025",
    type: "Cultural",
    status: "Active",
    country: "China",
  },
  {
    id: 18,
    name: "Anzac Day",
    date: "25/04/2025",
    type: "National",
    status: "Inactive",
    country: "Australia",
  },
  {
    id: 19,
    name: "Obon",
    date: "13/08/2025",
    type: "Cultural",
    status: "Active",
    country: "Japan",
  },
];